module.exports = __webpack_public_path__ + "static/img/volkswagen-cs-education.17176dc.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing/volkswagen-cs-education.jpg
// module id = dpMc
// module chunks = 0